import { render } from "./ApprovalFormDetail.vue?vue&type=template&id=253e4dd0&scoped=true"
import script from "./ApprovalFormDetail.vue?vue&type=script&lang=ts"
export * from "./ApprovalFormDetail.vue?vue&type=script&lang=ts"

import "./ApprovalFormDetail.vue?vue&type=style&index=0&id=253e4dd0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-253e4dd0"

export default script